import styled from 'styled-components'
import { Modal } from 'react-bootstrap'

export const StyledModal = styled(Modal)`
  .modal-dialog {
    max-width: 90vw;
    width: 1400px;
  }

  .modal-content {
    background: #1a1a1a;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    color: white;
    height: 90vh;
  }

  .modal-body {
    padding: 20px;
    overflow: hidden;
    height: calc(90vh - 130px); /* Account for header and footer */

    form {
      height: 100%;
    }
  }

  .modal-header {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .modal-footer {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }

  .form-label {
    color: rgba(255, 255, 255, 0.8);
  }

  .form-control,
  .form-select {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: white;

    &:focus {
      background: rgba(255, 255, 255, 0.1);
      border-color: var(--bs-primary);
      color: white;
      box-shadow: 0 0 0 0.25rem rgba(var(--bs-primary-rgb), 0.25);
    }
  }

  /* Style for select elements only */
  .form-select {
    /* Custom dropdown arrow */
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 16px 12px;
  }

  /* Style for dropdown options */
  .form-select option {
    background-color: #1a1a1a;
    color: white;
  }

  /* Style for dropdown when opened */
  .form-select:focus option:hover,
  .form-select:focus option:checked {
    background: var(--bs-primary);
    color: white;
  }

  /* Style for file input */
  .form-control[type='file'] {
    &::file-selector-button {
      background: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.2);
      color: white;
      margin-right: 1rem;
      padding: 0.375rem 0.75rem;
      border-radius: 0.25rem;
      transition: all 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.2);
        border-color: rgba(255, 255, 255, 0.3);
      }
    }
  }

  /* Style for form check (switch) */
  .form-check-input {
    background-color: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.2);

    &:checked {
      background-color: var(--bs-primary);
      border-color: var(--bs-primary);
    }

    &:focus {
      border-color: var(--bs-primary);
      box-shadow: 0 0 0 0.25rem rgba(var(--bs-primary-rgb), 0.25);
    }
  }

  .form-check-label {
    color: rgba(255, 255, 255, 0.8);
  }

  /* Style for helper text */
  .form-text {
    color: rgba(255, 255, 255, 0.6);
    font-size: 0.8rem;
    margin-top: 0.25rem;
  }
`

export const FormSection = styled.div`
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  h5 {
    color: var(--bs-primary);
    margin-bottom: 1rem;
  }
`

export const FormContainer = styled.div`
  flex: 1;
  min-width: 400px;
  overflow-y: auto;
  padding-right: 20px;
`
